__webpack_require__.p = "https://vodafone.dev.billing.affinity.io/";